// extracted by mini-css-extract-plugin
export default {"container":"FeesQuoteDetail_container__6cbXt","subTitle":"FeesQuoteDetail_subTitle__hgRZb","textTotal":"FeesQuoteDetail_textTotal__+pr9U"};